module.exports = __webpack_public_path__ + "img/class.5771293a.png";